const DCP_ENV = require('dcp/common/dcp-env');
const { SchedMsgNode } = require('./schedmsg-node');
const { SchedMsgWeb } = require('./schedmsg-web');

Object.assign(module.exports, {
  SchedMsg: (DCP_ENV.platform === 'nodejs'
    ? SchedMsgNode : SchedMsgWeb),
});
